const _warnedOnce = new Set<string>();

export function warnOnce(msg: string): void {
  if (_warnedOnce.has(msg)) return;
  _warnedOnce.add(msg);
  console.warn('[api]', msg);
}

/** Test helper — clears the dedup set so warnOnce fires fresh in each spec. */
export function _resetWarnOnce(): void {
  _warnedOnce.clear();
}
